export default __webpack_public_path__ + "static/media/vaisselle.32e34652.jpg";